import themeUtils from '../themeUtils';

export default class DynamicPromotion {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.adjustHeight = this.adjustHeight.bind(this);
    this._headerOffset = this._headerOffset.bind(this);
    this.$window = $(window);
    this.$body = $('body');
    this.$header = $('[data-section-type="header"]');

    this.$parent = this.$el.parent();
    this.$wrapper = $('[data-promotion-wrapper]', this.$el);
    this.$content = $('[data-promotion-content]', this.$el);
    this.$image = $('[data-promotion-image]', this.$el);
    this.$imageContainer = $('[data-promotion-image-container]', this.$el);

    this.isFullScreen = section.data.layout === 'full-screen';

    this._bindEvents();
    return this.adjustHeight();
  }

  remove() {
    this.$window.off('.home-promotion');
  }

  onSectionUnload() {
    this.remove();
  }

  onSectionReorder() {
    return this._headerOffset();
  }

  adjustHeight() {
    const heights = [];

    // An image can be shorter than text
    if (this.$imageContainer.length) {
      if (this.$content.length) {
        heights.push(this.$content.outerHeight(true));
      }

      if (this.$image.length) {
        heights.push(this.$image.outerHeight(true));
      }

      const minHeight = Math.max.apply(null, heights);

      this.$imageContainer.css({ minHeight });
    }

    return this._headerOffset();
  }

  _bindEvents() {
    this.$window.on('resize.home-promotion', themeUtils.debounce(this.adjustHeight, 100));
    return this.$window.on('scroll.home-promotion', themeUtils.debounce(this.adjustHeight, 10));
  }

  // Adjust container to compensate for header height if its in viewport
  _headerOffset() {
    let newHeight;
    if (!this.isFullScreen) { return; }

    const headerHeight = this.$header.outerHeight(true);
    const headerScrolledHeight = this.$header.find('.navigation').outerHeight(true);
    const isFirstChild = this.$parent.is(':first-child');
    const isStickyEnabled = this.$body.hasClass('sticky-header');
    const maxHeight = this.$window.height();

    if (themeUtils.isMedium()) {
      this.$wrapper.css('height', '');
    }

    // If is first child, always make it full screen minus header height
    if (isFirstChild) {
      newHeight = maxHeight - headerHeight;
      this.$wrapper.height(newHeight);

      // Otherwise, if its larger than tablet, and sticky is enabled, take off nav height
    } if (!themeUtils.isMedium() && isStickyEnabled) {
      newHeight = maxHeight - headerScrolledHeight;
      this.$wrapper.height(newHeight);

      // Is not tablet, and header is not sticky, remove offset
    }
    this.$wrapper.css('height', '');
  }
}
